/* eslint-disable jsx-a11y/alt-text */

import {useState, useEffect} from 'react'
import {Modal} from 'react-bootstrap'
import {toast} from 'react-toastify'
import {
  IMPORT_SCAN_PATIENTS,
  UPLOAD_INVENTORY,
} from '../../../../PharmaModule/GraphQLQueries/mutation'
import {LoadingSpinner} from '../../../../../../_ePulse/layout/components/LoadingSpinner'
import {GET_SAMPLE_FILE_URL} from '../../../../../common/GraphQLQuries/common'
import useApi from '../../../../../../hooks/useQuery'
import {ToastMessageContainer} from '../../../../../../_ePulse/layout/components/ToastMessageContainer'
import useMutationApi from '../../../../../../hooks/useMutation'

export const Popup = (props: any) => {
  const [errorMessage, setErrorMessage] = useState('')
  const [fileType, setFileType] = useState('')
  const [fileName, setFileName] = useState('')
  const [fileSize, setFileSize] = useState('')
  const [base64String, setBase64String] = useState('')
  const [sampleFileName, setSampleFileName] = useState('')
  const [excelURL, setExcelURL] = useState('')
  const [csvURL, setCsvURL] = useState('')
  const [isloading, setLoading] = useState(false)

  const formatFileSize = (file: any) => {
    const fileSizeInKB = file / 1024 // 1 KB = 1024 Bytes
    const fileSizeInMB = fileSizeInKB / 1024 // 1 MB = 1024 KB

    if (fileSizeInMB >= 1) {
      return fileSizeInMB.toFixed(2) + ' MB'
    } else {
      return fileSizeInKB.toFixed(2) + ' KB'
    }
  }

  const handelFileChange = (event: any) => {
    const file = event.target.files[0]
    if (
      file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      file.type === 'text/csv'
    ) {
      setFileName(file.name)
      setFileSize(formatFileSize(file.size))
      setFileType(file.type)

      setErrorMessage('')

      if (file) {
        const reader = new FileReader()
        reader.onloadend = () => {
          const b64 = reader.result as string
          setBase64String(b64?.replace(/^data:[^;]+;base64,/, ''))
        }
        reader.readAsDataURL(file)
      }
    } else {
      setErrorMessage('File type Must be Excel or Csv')
    }
  }

  const { createData} = useMutationApi( IMPORT_SCAN_PATIENTS);

  const uploadFile = async () => {
    try {
      setLoading(true)
      const data = await createData({
        fileDataString: base64String,
        fileMimeType: fileType,
        fileName: fileName,
      });
      toast.success( data?.data?.importScanCenterPatients)
      props.refetch()
      reset()
    } catch (error : any) {
      if (error?.networkError?.statusCode === 440) {
        toast.error(`${error?.networkError?.result?.errors[0]?.message}`)
      } else {
        // toast.error(`${error?.message}`)
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const reset = () => {
    setErrorMessage('')
    setFileName('')
    setFileSize('')
    props.setModalState(false)
  }

  const {
    data: fileURLData,
    loading: fileURLDataloading,
    error: fileURLDataerror,
    refetch: fileURLDatarefetch,
  } = useApi(true, GET_SAMPLE_FILE_URL, {
    fileKey: 'patientsUpload',
  })

  console.log(fileURLData, 'fileURLData in patient upload modal')

  useEffect(() => {
    if (fileURLData) {
      setSampleFileName(fileURLData?.getSampleDownloadableFileUrl)
      setExcelURL(fileURLData?.getSampleDownloadableFileUrl?.EXCEL)
      setCsvURL(fileURLData?.getSampleDownloadableFileUrl?.CSV)
    }
  }, [fileURLData])

  const removeFile = () => {
    setFileName('')
    setFileSize('')
    setErrorMessage('')
  }

  return (
    <>
      <LoadingSpinner isLoading={isloading} />
      <ToastMessageContainer />
      <Modal
        show={props.modalState}
        dialogClassName='ePulse-modal ePulse-modal-50w'
        onHide={() => props.setModalState(false)}
        backdrop='static'
      >
        <Modal.Header className='border-0' closeButton onClick={reset}>
          <span className='fs-3 fw-bold'>Upload Patient</span>
        </Modal.Header>

        <Modal.Body className='container' />
        <div style={{marginLeft: 16}}>
          <input
            type='file'
            id='upload'
            onChange={handelFileChange}
            hidden
            accept='.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
          />
          <label htmlFor='upload' className='ePulse-button3 ms-2'>
            Choose File
          </label>
          <span
            style={{
              marginLeft: 8,
            }}
          >
            {fileName}
          </span>

          {'   '}
          {fileSize !== '' ? <span>({fileSize})</span> : null}
          {fileName !== '' ? (
            <span style={{marginLeft: 16}} onClick={removeFile}>
              <img
                style={{width: 25, height: 25, cursor: 'pointer'}}
                src={'/media/ePulse/CrossIcon.png'}
              />
            </span>
          ) : null}
        </div>
         <div className='d-flex flex-row justify-content-end align-items-center mt-3'>
              <div className='d-flex flex-column justify-content-between align-items-center'>
                <span style={{marginRight:"10px"}}>Download Sample File</span>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  {csvURL && (
                    <u className='ePulse-textColor-primary me-5'>
                      <a href={csvURL}>CSV</a>
                    </u>
                  )}
                  {excelURL && (
                    <u className='ePulse-textColor-primary me-5'>
                      <a href={excelURL}>Excel</a>
                    </u>
                  )}
                </div>
              </div>
            </div>

        {errorMessage !== '' ? (
          <p style={{color: 'red', marginLeft: 16, marginTop: 6}}>{errorMessage}</p>
        ) : null}
        <div className='display-modal '>
          <button className='ePulse-btn-primary' onClick={uploadFile}>
            Upload
          </button>
        </div>
      </Modal>
    </>
  )
}
